import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const fetchSlots = async (eventPk, tierPk, date) => {
  const response = await axios.get(
    routes.ticketTierSlots(eventPk, tierPk) + `?date=${date}`,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default fetchSlots;
